import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import cn from 'classnames';
import './lower-sticky-note.scss';
function NoteContainer({ withImage, children }) {
    const classes = cn('content', { 'with-image': withImage });
    return (React.createElement("div", { className: classes }, children));
}
function NoteWithImage({ bannerInfo }) {
    return (React.createElement(NoteContainer, { withImage: true },
        React.createElement("img", { src: bannerInfo.banner_thumbnail, height: "70", width: "70", alt: "" }),
        React.createElement("div", { className: "text-side" },
            React.createElement(RawHTML, { className: "blurb", html: bannerInfo.html_message }),
            React.createElement("a", { className: "cta", href: bannerInfo.link_url, "data-nudge-action": "interacted" },
                bannerInfo.link_text,
                React.createElement(FontAwesomeIcon, { icon: faChevronRight })))));
}
function NoteWithoutImage({ bannerInfo }) {
    return (React.createElement(NoteContainer, { withImage: false },
        React.createElement(RawHTML, { className: "blurb", html: bannerInfo.html_message }),
        React.createElement("a", { className: "cta", href: bannerInfo.link_url, "data-nudge-action": "interacted" },
            React.createElement(FontAwesomeIcon, { icon: faHeart, className: "red-heart" }),
            bannerInfo.link_text,
            React.createElement(FontAwesomeIcon, { icon: faChevronRight }))));
}
export default function LowerStickyNote({ stickyData, PutAway }) {
    return (React.createElement("div", { className: cn('lower-sticky-note-content', { 'with-image': stickyData.bannerInfo.banner_thumbnail }), "data-analytics-view": true, "data-analytics-nudge": "donate", "data-nudge-placement": "banner", role: "dialog", "aria-label": "sticky note" },
        React.createElement(PutAway, null),
        stickyData.bannerInfo.banner_thumbnail ?
            React.createElement(NoteWithImage, { bannerInfo: stickyData.bannerInfo }) :
            React.createElement(NoteWithoutImage, { bannerInfo: stickyData.bannerInfo })));
}
